import _extends from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "showMoreText", "defaultItems", "enableShowMore", "gridGap", "minColWidth", "maxColWidth"];
var __jsx = React.createElement;
import React, { useState } from 'react';
import styled from 'styled-components';
import Button from "./Button";
export var GridTemplate = styled.div.withConfig({
  displayName: "FlexGrid__GridTemplate",
  componentId: "sc-1s49z53-0"
})(["display:grid;grid-template-columns:repeat( auto-fill,minmax(", ") );grid-gap:", ";"], function (props) {
  return "".concat(props.minColWidth, ", ").concat(props.maxColWidth);
}, function (props) {
  return props.gridGap;
});
export var GridFooter = styled.div.withConfig({
  displayName: "FlexGrid__GridFooter",
  componentId: "sc-1s49z53-1"
})(["text-align:right;padding:1.75rem 0 0;"]);

// not in use
var FlexGrid = function FlexGrid(_ref) {
  var children = _ref.children,
    _ref$showMoreText = _ref.showMoreText,
    showMoreText = _ref$showMoreText === void 0 ? 'More' : _ref$showMoreText,
    _ref$defaultItems = _ref.defaultItems,
    defaultItems = _ref$defaultItems === void 0 ? 3 : _ref$defaultItems,
    _ref$enableShowMore = _ref.enableShowMore,
    enableShowMore = _ref$enableShowMore === void 0 ? false : _ref$enableShowMore,
    _ref$gridGap = _ref.gridGap,
    gridGap = _ref$gridGap === void 0 ? '20px' : _ref$gridGap,
    _ref$minColWidth = _ref.minColWidth,
    minColWidth = _ref$minColWidth === void 0 ? '270px' : _ref$minColWidth,
    _ref$maxColWidth = _ref.maxColWidth,
    maxColWidth = _ref$maxColWidth === void 0 ? '1fr' : _ref$maxColWidth,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    isShowingMore = _useState[0],
    setIsShowingMore = _useState[1];
  var showMore = function showMore() {
    setIsShowingMore(true);
  };
  var gridItems = React.Children.toArray(children);
  var shouldEnableShowMore = enableShowMore && gridItems.length > defaultItems;
  return __jsx("div", null, __jsx(GridTemplate, _extends({
    gridGap: gridGap,
    minColWidth: minColWidth,
    maxColWidth: maxColWidth
  }, restProps), shouldEnableShowMore && !isShowingMore ? gridItems.slice(0, defaultItems) : children), shouldEnableShowMore && !isShowingMore && __jsx(GridFooter, null, __jsx(Button, {
    onClick: showMore,
    outline: true
  }, showMoreText)));
};
export default FlexGrid;